import { render } from "./gserver.vue?vue&type=template&id=336f6bec"
import script from "./gserver.vue?vue&type=script&lang=js"
export * from "./gserver.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__